// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"85":"566c49068e0c1182184c","418":"9f369b1064b48276432e","865":"566c49068e0c1182184c","4887":"566c49068e0c1182184c","7364":"566c49068e0c1182184c"}[chunkId] + ".chunk.css";
};